module.exports = __webpack_public_path__ + "488ee5af4209b7da6d640fa226d0e22b.svg";